import { Button } from '@worldcoo/ui/components/button';
import { useLingui } from '@lingui/react/macro';
import { createFileRoute, Link } from '@tanstack/react-router';
import { Animate } from '@worldcoo/ui/custom/animate';
import { useEphemeralStore } from '@/lib/app-store';
import { DonateStepPending } from './-components/donate-step-pending';

export const Route = createFileRoute('/$portalId/$campaignId/donate/thanks')({
	head: () => ({ meta: [{ name: 'robots', content: 'noindex' }] }),
	component: RouteComponent,
	pendingComponent: DonateStepPending,
});

function RouteComponent() {
	const { t } = useLingui();
	const { portalId, campaignId } = Route.useParams();
	const donationConfirmed = useEphemeralStore((store) => store.donationConfirmed);

	return (
		<Animate>
			<div className="text-accent-foreground flex flex-col gap-3">
				<h1 className="text-center text-[40px] leading-[46px] -tracking-[0.2px]">{t`Thank you\n for your donation!`}</h1>
				<p className="text-center align-middle text-base font-medium">{t`You will soon receive a confirmation email with all the details. Together we are building a better future!`}</p>
			</div>

			<Button
				size="xl"
				className="mx-auto w-fit"
				asChild
				data-testid="view-campaign-button"
				data-donation-confirmed={donationConfirmed ? 'true' : 'false'}
			>
				<Link to="/$portalId/$campaignId" params={{ portalId, campaignId }} replace>
					{t`View campaign`}
				</Link>
			</Button>
		</Animate>
	);
}
